import WPStagingCommon from '../../wpstg.js';
import 'regenerator-runtime/runtime';
import WPStagingBackup from './wpstg-backup';

let WPStagingBackupRestore;

(function($) {
  window.addEventListener('backups-tab', function() {
    WPStagingBackupRestore.listen();
  });

  WPStagingBackupRestore = {
    listen() {
      $('body')
          .off('click', '.wpstg--backup--restore', WPStagingBackupRestore.clickedRestore)
          .on('click', '.wpstg--backup--restore', WPStagingBackupRestore.clickedRestore);
    },
    timer: {
      totalSeconds: 0,
      interval: null,
      start() {
        if (null !== WPStagingBackupRestore.timer.interval) {
          return;
        }
        const prettify = (seconds) => {
          return `${(new Date(seconds * 1000)).toISOString().substr(11, 8)}`;
        };

        WPStagingBackupRestore.timer.interval = setInterval(() => {
          $('.wpstg--modal--process--elapsed-time').text(prettify(WPStagingBackupRestore.timer.totalSeconds));
          WPStagingBackupRestore.timer.totalSeconds++;
        }, 1000);
      },
      stop() {
        WPStagingBackupRestore.timer.totalSeconds = 0;
        if (WPStagingBackupRestore.timer.interval) {
          clearInterval(WPStagingBackupRestore.timer.interval);
          WPStagingBackupRestore.timer.interval = null;
        }
      },
    },
    clickedRestore(e) {
      const currentObj = this;
      WPStaging.checkUserDbPermissions('restore').then(function() {
        WPStagingCommon.resetErrors();
        e.preventDefault();
        WPStagingBackup.isCancelled = false;
        WPStagingBackup.modal.restore.data.file = currentObj.getAttribute('data-filePath');
        WPStagingBackupRestore.selectedBackup();
      });
    },
    selectedBackup() {
      WPStagingCommon.ajax(
          {
            action: 'wpstg--backups--read-backup-metadata',
            accessToken: wpstg.accessToken,
            nonce: wpstg.nonce,
            wpstg: {
              file: WPStagingBackup.modal.restore.data.file,
            },
          },
          function(response) {
            let responseData;

            try {
              responseData = JSON.parse(WPStagingCommon.getDataFromWordPressResponse(response));
              // Get the first item of the blogs object:
              // blogs {1: {someData}} => {someData}
              const mainNetwork = responseData.networks[Object.keys(responseData.networks)[0]];
              const mainBlog = mainNetwork.blogs[Object.keys(mainNetwork.blogs)[0]];
              responseData = mainBlog;
            } catch (e) {
              WPStagingCommon.showError(e);
            }

            WPStagingBackup.modal.restore.data.backupMetadata = responseData;

            const postData = new FormData();
            postData.append('action', 'wpstg--backups--restore--file-info');
            postData.append('accessToken', wpstg.accessToken);
            postData.append('nonce', wpstg.nonce);
            postData.append('filePath', WPStagingBackup.modal.restore.data.file);

            fetch(ajaxurl, {
              method: 'POST',
              body: postData,
            })
                .then(WPStagingCommon.handleFetchErrors)
                .then((res) => res.json())
                .then((html) => {
                  WPStagingBackup.modal.restore.retryCount = 0;
                  WPStagingBackupRestore.importModal(html, postData);
                })
                .catch((e) => WPStagingCommon.showAjaxFatalError(e, '', 'Submit an error report.'));

            $('.wpstg--modal--actions .wpstg--swal2-confirm').show();
            $('.wpstg--modal--actions .wpstg--swal2-confirm').prop('disabled', false);
          },
      );
    },
    importModal(confirmHtml) {
      const importSiteBackup = (data, retryRequest = false, errorCode = null) => {
        WPStagingCommon.resetErrors();

        if (WPStagingBackup.isCancelled) {
          WPStagingBackup.statusStop();
          return;
        }

        WPStagingBackup.timer.start();

        window.addEventListener('beforeunload', WPStaging.warnIfClosingDuringProcess);

        WPStagingCommon.ajax(
            {
              action: 'wpstg--backups--restore',
              accessToken: wpstg.accessToken,
              nonce: wpstg.nonce,
              retry: retryRequest,
              errorCode: errorCode,
            },
            async function(response) {
              if (WPStagingBackup.isCancelled) {
                return;
              }

              // reset retry count on success
              WPStagingCommon.retry.reset();

              if (typeof response === 'undefined') {
                setTimeout(function() {
                  importSiteBackup(data);
                }, wpstg.delayReq);
                return;
              }

              WPStagingBackup.processResponse(response);
              if (!WPStagingBackup.processInfo.interval) {
                WPStagingBackup.statusStart('restore');
              }

              if (response.isRunning === true) {
                importSiteBackup(data);
              } else if (response.jobStatus === 'JOB_FAIL') {
                await WPStagingBackup.checkMemoryExhaustion(response, 'wpstg_restore');
                setTimeout(function() {
                  importSiteBackup(data);
                }, wpstg.delayReq);
              } else {
                window.removeEventListener('beforeunload', WPStaging.warnIfClosingDuringProcess);
                $('#wpstg--progress--status').text('Backup successfully imported!');
                if (WPStagingBackup.messages.shouldWarn()) {
                  WPStagingBackup.logsModal();
                  return;
                }
                WPStagingBackup.statusStop();
                const logEntries = $('.wpstg-backup-success-logs').innerHTML;
                const html = '<div class="wpstg-backup-success-logs">' + logEntries + '</div>';
                const issueFound = html.includes('wpstg--modal--process--msg--warning') || html.includes('wpstg--modal--process--msg--error') ? 'Issues(s) found!<br> ' : '';

                const loginText = WPStagingBackup.modal.restore.data.backupMetadata.isExportingDatabase ? 'You will be redirected to the login page after closing this modal.' : '';

                // TODO: remove default classes.
                WPStagingCommon.getSwalModal(true, {
                  container: 'wpstg-restore-finished-container',
                }).fire({
                  icon: 'success',
                  title: 'Finished Successfully',
                  html: '<div id="wpstg-restore-success" class="wpstg--grey">Site has been restored from backup. ' + loginText + '  <br/><br/><span class="wpstg--modal--process--msg-found">' + issueFound + '</span><button class="wpstg-backup-success-logs-button" data-txt-bad="">Show Logs</button></div><br/>' + html,
                  onClose: function() {
                    if (WPStagingBackup.modal.restore.data.backupMetadata.isExportingDatabase) {
                      document.getElementById('wpstg-restore-wait').style.display = 'flex';

                      // Reload in 15 seconds if something goes wrong with the Ajax call.
                      setTimeout(function() {
                        document.location.reload(true);
                      }, 15000);

                      WPStagingCommon.ajax(
                          {
                            action: 'raw_wpstg--backups--login-url',
                            accessToken: wpstg.accessToken,
                            nonce: wpstg.nonce,
                          },
                          function(response) {
                            // When restoring on WordPress.com, login Url might be undefined due to private site settings.
                            if (response.data.loginUrl === undefined && response.data.code === 'private_site') {
                              return;
                            }

                            const loginUrl = new URL(response.data.loginUrl);
                            loginUrl.searchParams.set('accessToken', wpstg.accessToken);
                            loginUrl.searchParams.set('wpstgAfterRestore', 'yes');
                            if (WPStagingBackup.modal.restore.data.backupMetadata.isCreatedOnWordPressCom) {
                              loginUrl.searchParams.set('wpstgIsBackupCreatedOnWordPressCom', 'yes');
                            }

                            window.location.href = loginUrl.toString();
                          },
                      );
                    } else {
                      WPStagingBackup.fetchListing();
                    }
                  },
                },
                );
              }
            },
            'json',
            false,
            10, // Don't retry upon failure
            1.25,
            async (xhr, textStatus, errorThrown) => { // Callback function to handle retry for Backup Restore
              const errorCode = parseInt(xhr.status);

              await WPStagingBackup.checkMemoryExhaustion({messages: []}, 'wpstg_restore');

              if (!WPStagingCommon.retry.retryOnErrors.includes(errorCode)) {
                return;
              }

              if (!WPStagingCommon.retry.canRetry()) {
                return;
              }

              WPStagingCommon.continueErrorHandle = false;
              WPStagingCommon.retry.incrementRetry();
              const delay = WPStagingCommon.retry.currentDelay;

              setTimeout(async () => {
                // Mark this try, retry
                importSiteBackup(data, true, errorCode);
              }, delay);
            },
        );
      };

      const $modal = $('#wpstg--modal--backup--restore');

      WPStagingBackup.modal.restore.html = $modal.html();
      WPStagingBackup.modal.restore.baseDirectory = $modal.attr('data-baseDirectory');
      WPStagingBackup.modal.restore.btnTxtNext = $modal.attr('data-nextButtonText');
      WPStagingBackup.modal.restore.btnTxtConfirm = $modal.attr('data-confirmButtonText');
      WPStagingBackup.modal.restore.btnTxtCancel = $modal.attr('data-cancelButtonText');

      WPStagingCommon.getSwalModal()
          .mixin({
            progressSteps: ['1', '2'],
          })
          .queue([
            {
              html: $('.wpstg--modal--backup--restore--introduction').first(),
              confirmButtonText: 'Next',
              showCancelButton: true,
              showConfirmButton: true,
              reverseButtons: true,
              width: 600,
              onRender() {
                $('.wpstg--modal--backup--restore--introduction .wpstg-backup-restore-contains-database').hide();
                $('.wpstg--modal--backup--restore--introduction .wpstg-backup-restore-contains-database-multisite').hide();
                $('.wpstg--modal--backup--restore--introduction .wpstg-backup-restore-contains-files').hide();

                if (WPStagingBackup.modal.restore.data.backupMetadata.isExportingDatabase) {
                  $('.wpstg--modal--backup--restore--introduction .wpstg-backup-restore-contains-database').show();
                }

                if (WPStagingBackup.modal.restore.data.backupMetadata.isExportingDatabase && WPStagingBackup.modal.restore.data.backupMetadata.singleOrMulti === 'multi') {
                  $('.wpstg--modal--backup--restore--introduction .wpstg-backup-restore-contains-database-multisite').show();
                }

                if (
                  WPStagingBackup.modal.restore.data.backupMetadata.isExportingMuPlugins ||
                  WPStagingBackup.modal.restore.data.backupMetadata.isExportingPlugins ||
                  WPStagingBackup.modal.restore.data.backupMetadata.isExportingThemes ||
                  WPStagingBackup.modal.restore.data.backupMetadata.isExportingUploads ||
                  WPStagingBackup.modal.restore.data.backupMetadata.isExportingOtherWpContentFiles
                ) {
                  $('.wpstg--modal--backup--restore--introduction .wpstg-backup-restore-contains-files').show();
                }
              },
            },
            {
              html: confirmHtml,
              confirmButtonText: 'Restore',
              showCancelButton: true,
              showConfirmButton: true,
              reverseButtons: true,
              width: 650,
            },
          ])
          .then((res) => {
            // Early bail: Dismissed, canceled, or in a incoherent state.
            if (!res || !res.value) {
              return;
            }

            // Early bail: Step 1 (Confirm) must be true.
            if (!res.value[1] || res.value[1] !== true) {
              return;
            }

            WPStagingBackup.isCancelled = false;

            const data = WPStagingBackup.modal.restore.data;

            // Unset fileObject as we don't need it anymore, and it can't be converted to array.
            WPStagingBackup.modal.restore.data.fileObject = null;

            data['file'] = WPStagingBackup.modal.restore.baseDirectory + data['file'];

            WPStagingCommon.ajax(
                {
                  action: 'wpstg--backups--prepare-restore',
                  accessToken: wpstg.accessToken,
                  nonce: wpstg.nonce,
                  wpstgRestoreData: data,
                },
                function(response) {
                  if (response.success) {
                    WPStagingBackup.process({
                      execute: () => {
                        WPStagingBackup.messages.reset();
                        importSiteBackup(data);
                      },
                    });
                  } else {
                    WPStagingCommon.showAjaxFatalError(response.data, '', 'Submit an error report.');
                  }
                },
                'json',
                false,
                10,
                1.25,
                function(xhr, textStatus, errorThrown) {
                  if (xhr.status === 423) {
                    WPStagingCommon.continueErrorHandle = false;
                    WPStagingBackup.shouldCleanUp = false;
                    WPStagingCommon.closeSwalModal();

                    setTimeout(function() {
                      WPStagingBackup.shouldCleanUp = true;
                    }, 1000);
                    WPStagingCommon.showErrorModal(xhr.responseJSON.data);
                  } else {
                    WPStagingCommon.continueErrorHandle = true;
                  }
                },
            );
          });
    },
  };
}(jQuery));

export default WPStagingBackupRestore;
